window.initAjaxFacetsPage = function (rootId, scrollTargetId, options) {
  options = options || {};
  const container = document.getElementById(rootId);
  if (!container) return;

  const sectionId = container.dataset.sectionId;
  const baseUrl = container.dataset.sectionUrl || window.location.pathname;

  const filterForm = () => container.querySelector('#FilterForm');
  const sortSelect = () => container.querySelector('#SortBy');
  const productGrid = () => container.querySelector('[data-product-grid]');
  const productCount = () => container.querySelector('[data-product-count]');
  const facetsWrap = () => container.querySelector('[data-facets]');
  const paginationWrap = () => container.querySelector('[data-pagination]');
  const bodyWrap = () => container.querySelector('[data-collection-body]');
  const priceRangeEl = () => container.querySelector('[data-price-range]');

  function scrollToMain() {
    const el = document.getElementById(scrollTargetId);
    if (!el) return;
    el.scrollIntoView({ behavior: 'auto', block: 'start' });
    if (window.location.hash === '#' + scrollTargetId) {
      window.history.replaceState({}, '', window.location.pathname + window.location.search);
    }
  }

  const parseNumber = (v) => {
    if (v == null) return NaN;
    const s = String(v).replace(/\s/g, '').replace(',', '.');
    const n = Number(s);
    return Number.isFinite(n) ? n : NaN;
  };
  const clamp = (x, a, b) => Math.min(b, Math.max(a, x));
  const toCents = (eur) => {
    const n = parseNumber(eur);
    if (!Number.isFinite(n)) return '';
    return Math.round(n * 100);
  };

  function priceUnit() {
    const unit = priceRangeEl()?.dataset?.unit?.toLowerCase();
    return unit === 'eur' ? 'eur' : 'cents';
  }

  function paramsFromForm(page) {
    const form = filterForm();
    const usp = new URLSearchParams();
    const unit = priceUnit();

    if (form) {
      const fd = new FormData(form);
      for (const [name, value] of fd.entries()) {
        if (value === '' || value == null) continue;
        if (name.includes('filter.v.price.gte') || name.includes('filter.v.price.lte')) {
          const out = unit === 'cents' ? toCents(value) : parseNumber(value);
          if (out !== '' && Number.isFinite(out)) usp.set(name, String(out));
        } else {
          usp.append(name, value);
        }
      }
    }

    if (!usp.has('q')) {
      const q = container.dataset.searchQuery;
      if (q) usp.set('q', q);
      else {
        const urlQ = new URLSearchParams(window.location.search).get('q');
        if (urlQ) usp.set('q', urlQ);
      }
    }
    if (!usp.has('type') && (container.dataset.searchType || baseUrl.indexOf('/search') !== -1)) {
      usp.set('type', container.dataset.searchType || 'product');
    }
    if (!usp.has('options[prefix]')) {
      usp.set('options[prefix]', 'last');
    }

    if (sortSelect() && sortSelect().value) usp.set('sort_by', sortSelect().value);
    if (page != null && String(page) !== '' && String(page) !== '1') {
      usp.set('page', String(page));
    }
    return usp.toString();
  }

  let isFetching = false;
  async function fetchSection(queryString) {
    if (isFetching) return;
    isFetching = true;
    const url = baseUrl + '?section_id=' + encodeURIComponent(sectionId) + (queryString ? '&' + queryString : '');

    const res = await fetch(url, { headers: { 'X-Requested-With': 'XMLHttpRequest' } }).catch(() => null);
    if (!res || !res.ok) {
      isFetching = false;
      return;
    }

    const html = await res.text();
    const doc = new DOMParser().parseFromString(html, 'text/html');

    const newGrid = doc.querySelector('[data-product-grid]');
    const newCount = doc.querySelector('[data-product-count]');
    const newFacets = doc.querySelector('[data-facets]');
    const newPagination = doc.querySelector('[data-pagination]');

    if (newGrid && productGrid()) productGrid().replaceWith(newGrid);
    if (newCount && productCount()) productCount().replaceWith(newCount);
    if (newFacets && facetsWrap()) facetsWrap().replaceWith(newFacets);

    if (paginationWrap()) {
      if (newPagination) paginationWrap().replaceWith(newPagination);
      else paginationWrap().remove();
    } else if (newPagination && bodyWrap()) {
      bodyWrap().appendChild(newPagination);
    }

    const newUrl = baseUrl + (queryString ? '?' + queryString : '');
    window.history.replaceState({}, '', newUrl);

    setupAllPriceRanges();
    if (typeof options.fixTextSlider === 'function') options.fixTextSlider();
    initCheckboxStates();
    expandActiveFilterSections();
    scrollToMain();
    isFetching = false;
  }

  function onFilterSubmit(e) {
    if (!e.target.closest || !e.target.closest('#FilterForm')) return;
    e.preventDefault();
    fetchSection(paramsFromForm()).catch(console.error);
  }
  function onSortChange(e) {
    if (!e.target.matches || !e.target.matches('#SortBy')) return;
    fetchSection(paramsFromForm()).catch(console.error);
  }
  function onNiceSelectClick(e) {
    const opt = e.target.closest('.nice-select .option');
    if (!opt) return;
    const value = opt.dataset.value || opt.getAttribute('data-value');
    if (!value || !sortSelect()) return;
    sortSelect().value = value;
    sortSelect().dispatchEvent(new Event('change', { bubbles: true }));
  }
  function onFacetChange(e) {
    const form = filterForm();
    if (!form || !e.target || !form.contains(e.target)) return;
    if (e.target.type === 'checkbox') {
      const checkbox = e.target;
      const label = checkbox.closest('label.checkbox');
      const checkDiv = label && label.querySelector('.check');
      if (label && checkDiv) {
        label.classList.toggle('checked', checkbox.checked);
        checkDiv.classList.toggle('active', checkbox.checked);
      }
      fetchSection(paramsFromForm()).catch(console.error);
    }
    if (e.target.name && e.target.name.includes('filter.v.price')) {
      clearTimeout(onFacetChange._t);
      onFacetChange._t = setTimeout(function () {
        fetchSection(paramsFromForm()).catch(console.error);
      }, 250);
    }
  }
  function onMobileSortClick(e) {
    const a = e.target.closest('[data-mobile-sort] a[data-sort-value]');
    if (!a) return;
    e.preventDefault();
    if (sortSelect()) sortSelect().value = a.dataset.sortValue;
    fetchSection(paramsFromForm()).catch(console.error);
  }
  function onPaginationClick(e) {
    const link = e.target.closest('a[href]');
    if (!link || !link.closest('[data-pagination]')) return;
    e.preventDefault();
    const url = new URL(link.href, window.location.origin);
    fetchSection(paramsFromForm(url.searchParams.get('page'))).catch(console.error);
  }

  function bindEvents() {
    container.addEventListener('submit', onFilterSubmit);
    container.addEventListener('change', onSortChange);
    container.addEventListener('change', onFacetChange);
    container.addEventListener('click', onMobileSortClick);
    container.addEventListener('click', onPaginationClick);
    container.addEventListener('click', onNiceSelectClick);
  }

  const clientX = (e) => (e.touches && e.touches[0]) ? e.touches[0].clientX : e.clientX;

  function setupAllPriceRanges() {
    container.querySelectorAll('[data-price-range]').forEach(setupPriceRange);
  }

  function setupPriceRange(el) {
    const scale = Number(el.dataset.scale) || 1;
    const min = Number(el.dataset.min) / scale;
    const max = Number(el.dataset.max) / scale;
    let start = Number(el.dataset.start) / scale;
    let end = Number(el.dataset.end) / scale;
    const hasMin = String(el.dataset.hasMin) === 'true';
    const hasMax = String(el.dataset.hasMax) === 'true';

    if (!Number.isFinite(start) || !hasMin) start = min;
    if (!Number.isFinite(end) || !hasMax) end = max;

    const track = el.querySelector('.range-track');
    const fill = el.querySelector('.range-fill');
    const hMin = el.querySelector('.min-handle');
    const hMax = el.querySelector('.max-handle');
    const spanMin = el.querySelector('.min-price');
    const spanMax = el.querySelector('.max-price');
    const inMin = el.querySelector('.price-hidden-min');
    const inMax = el.querySelector('.price-hidden-max');
    const paramMin = el.dataset.paramMin;
    const paramMax = el.dataset.paramMax;
    if (!track || !hMin || !hMax || !fill || !spanMin || !spanMax || !inMin || !inMax) return;

    start = clamp(start, min, max);
    end = clamp(end, min, max);
    if (start > end) {
      const tmp = start;
      start = end;
      end = tmp;
    }

    const toPct = (v) => ((v - min) / (max - min)) * 100;

    function syncPriceInputNames() {
      if (paramMin) {
        if (Math.round(start) > Math.round(min)) inMin.setAttribute('name', paramMin);
        else inMin.removeAttribute('name');
      }
      if (paramMax) {
        if (Math.round(end) < Math.round(max)) inMax.setAttribute('name', paramMax);
        else inMax.removeAttribute('name');
      }
    }

    function render() {
      const p1 = toPct(start);
      const p2 = toPct(end);
      hMin.style.left = p1 + '%';
      hMax.style.left = p2 + '%';
      fill.style.left = Math.min(p1, p2) + '%';
      fill.style.width = Math.abs(p2 - p1) + '%';
      spanMin.textContent = String(Math.round(start));
      spanMax.textContent = String(Math.round(end));
      inMin.value = String(Math.round(start));
      inMax.value = String(Math.round(end));
      syncPriceInputNames();
    }
    render();

    let active = null;
    function onDown(e) {
      const handle = e.target.closest('.range-handle');
      if (!handle) return;
      e.preventDefault();
      active = handle.classList.contains('min-handle') ? 'min' : 'max';
      window.addEventListener('pointermove', onMove);
      window.addEventListener('pointerup', onUp, { once: true });
      window.addEventListener('mousemove', onMove);
      window.addEventListener('mouseup', onUp, { once: true });
      window.addEventListener('touchmove', onMove, { passive: false });
      window.addEventListener('touchend', onUp, { once: true });
    }
    function onMove(e) {
      const rect = track.getBoundingClientRect();
      let pct = ((clientX(e) - rect.left) / rect.width) * 100;
      pct = clamp(pct, 0, 100);
      const val = Math.round(min + (pct / 100) * (max - min));
      if (active === 'min') start = clamp(val, min, end);
      else if (active === 'max') end = clamp(val, start, max);
      render();
    }
    function onUp() {
      window.removeEventListener('pointermove', onMove);
      window.removeEventListener('mousemove', onMove);
      window.removeEventListener('touchmove', onMove);
      active = null;
      clearTimeout(el._t);
      el._t = setTimeout(function () {
        fetchSection(paramsFromForm()).catch(console.error);
      }, 150);
    }

    track.addEventListener('click', function (e) {
      const rect = track.getBoundingClientRect();
      let pct = ((clientX(e) - rect.left) / rect.width) * 100;
      pct = clamp(pct, 0, 100);
      const val = Math.round(min + (pct / 100) * (max - min));
      if (Math.abs(val - start) <= Math.abs(val - end)) start = clamp(val, min, end);
      else end = clamp(val, start, max);
      render();
      clearTimeout(el._t);
      el._t = setTimeout(function () {
        fetchSection(paramsFromForm()).catch(console.error);
      }, 150);
    });

    hMin.addEventListener('pointerdown', onDown);
    hMax.addEventListener('pointerdown', onDown);
    hMin.addEventListener('mousedown', onDown);
    hMax.addEventListener('mousedown', onDown);
    hMin.addEventListener('touchstart', onDown, { passive: true });
    hMax.addEventListener('touchstart', onDown, { passive: true });
  }

  function isPriceFilterActive(priceRange) {
    if (!priceRange) return false;
    return priceRange.dataset.hasMin === 'true' || priceRange.dataset.hasMax === 'true';
  }

  function expandActiveFilterSections() {
    const form = filterForm();
    if (!form) return;
    form.querySelectorAll('.sidebar_left_wraps.filter-collapsible').forEach(function (wrap) {
      const priceRange = wrap.querySelector('[data-price-range]');
      const hasChecked = wrap.querySelector('.checkbox.v2 input[type="checkbox"]:checked');
      const priceActive = isPriceFilterActive(priceRange);

      if (priceRange) {
        if (priceActive) {
          wrap.classList.add('active');
          const top = wrap.querySelector('.side_bar_top');
          if (top) top.setAttribute('aria-expanded', 'true');
        }
        return;
      }

      if (hasChecked) {
        wrap.classList.add('active');
        const top = wrap.querySelector('.side_bar_top');
        if (top) top.setAttribute('aria-expanded', 'true');
      }
    });
  }

  function initCheckboxStates() {
    container.querySelectorAll('.checkbox.v2 input[type="checkbox"]').forEach(function (checkbox) {
      const label = checkbox.closest('label.checkbox');
      const checkDiv = label && label.querySelector('.check');
      if (label && checkDiv) {
        label.classList.toggle('checked', checkbox.checked);
        checkDiv.classList.toggle('active', checkbox.checked);
      }
    });
  }

  bindEvents();
  setupAllPriceRanges();
  if (typeof options.fixTextSlider === 'function') options.fixTextSlider();
  initCheckboxStates();
  expandActiveFilterSections();

  window.addEventListener('load', scrollToMain);
  window.addEventListener('pageshow', function (e) {
    if (e.persisted) scrollToMain();
  });
};
